import { useEffect } from 'react';

import { loadAnalytics } from '../analytics/analytics-bridge';
import { identifyFromSession } from './session/session-identity';

/** Identifica o usuário quando o SDK de analytics estiver carregado, sem bloquear o render. */
export function useSessionIdentity(authenticated: boolean): void {
  useEffect(() => {
    if (!authenticated) {
      return undefined;
    }
    let active = true;
    // A promessa é a memoizada do carregamento: se o SDK ainda estiver subindo na montagem,
    // a identificação espera por ele em vez de depender de uma nova navegação.
    void loadAnalytics().then(() => {
      if (active) {
        identifyFromSession();
      }
    });
    return () => {
      active = false;
    };
  }, [authenticated]);
}
